import {Button} from "../../../../../shadCn/components/ui/button";
import React from "react";
import Section from "../../../../../components/section/Section";
import Th_title from "../../../../../components/Th_title";
import SimmsInput from "../../../../../components/input/SimmsInput";
import SimmsSelect from "../../../../../components/select/SimmsSelect";
import {inputType} from "../inspectionReportCodeConstants";
import ReadOnlyInputBasic from "../../../../../components/input/ReadOnlyInputBasic";

function InspectionReportCodeChildren({
    children,
    setChildren,
    status,
    variant = "default",
    activeGroupIndex = 0,
}) {
    function addChild(idx) {
        setChildren((prevChildren) =>
            prevChildren.map((group, groupIdx) =>
                groupIdx === idx
                    ? {
                        ...group,
                        child: [...group.child, {name: "", type: 0, etc: "", groupName: group.groupName}],
                    }
                    : group,
            ),
        );
    }

    function removeChild(index, idx) {
        setChildren((prevChildren) => {
            const targetGroup = prevChildren[index];

            if (targetGroup.child.length === 1) {
                return prevChildren.filter((_, groupIdx) => groupIdx !== index);
            }

            return prevChildren.map((group, groupIdx) =>
                groupIdx === index
                    ? {
                        ...group,
                        child: group.child.filter((_, childIdx) => childIdx !== idx),
                    }
                    : group,
            );
        });
    }

    function removeGroup(index) {
        setChildren((prevChildren) => prevChildren.filter((_, groupIdx) => groupIdx !== index));
    }

    function handleChild(index, t, v, idx) {
        setChildren((prevChildren) =>
            prevChildren.map((group, groupIdx) =>
                groupIdx === index
                    ? {
                        ...group,
                        child: group.child.map((child, childIdx) =>
                            childIdx === idx ? {...child, [t]: v} : child,
                        ),
                    }
                    : group,
            ),
        );
    }

    if (variant === "create" && children?.length > 0) {
        const index = Math.min(Math.max(activeGroupIndex, 0), children.length - 1);
        const each = children[index];
        const ROW_H = 38;
        const CELL_LINE = "#e5e7eb";
        const INPUT_LINE = "#eeeeee";

        const cellLabelStyle = {
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
            padding: "0 10px",
            fontSize: 12,
            fontWeight: 600,
            color: "#6b7280",
            background: "#f9fafb",
            borderRight: `1px solid ${CELL_LINE}`,
            boxSizing: "border-box",
        };
        const valueCellStyle = {
            minWidth: 0,
            display: "flex",
            alignItems: "stretch",
            borderRight: `1px solid ${CELL_LINE}`,
            background: "#fff",
            boxSizing: "border-box",
        };
        const inputStyle = {
            width: "100%",
            height: ROW_H,
            padding: "0 12px",
            fontSize: 13,
            color: "#191f28",
            background: "#fff",
            border: `1px solid ${INPUT_LINE}`,
            borderRadius: 0,
            boxSizing: "border-box",
        };
        const selectStyle = {width: "100%"};
        const removeBtnStyle = {
            flexShrink: 0,
            width: 36,
            height: ROW_H,
            padding: 0,
            fontSize: 17,
            lineHeight: 1,
            color: "#b0b8c1",
            background: "#fff",
            border: "none",
            borderRadius: 0,
            cursor: "pointer",
        };

        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    minHeight: 0,
                }}
            >
                {status !== "VIEW" && (
                    <div
                        style={{
                            flexShrink: 0,
                            padding: "6px 12px",
                            borderBottom: "1px solid #eef0f3",
                        }}
                    >
                        <button
                            type="button"
                            style={{
                                padding: "4px 2px",
                                fontSize: 13,
                                fontWeight: 600,
                                color: "#3182f6",
                                background: "transparent",
                                border: "none",
                                cursor: "pointer",
                            }}
                            onClick={() => addChild(index)}
                        >
                            + 점검항목 추가
                        </button>
                    </div>
                )}
                <div
                    style={{
                        flex: 1,
                        minHeight: 0,
                        overflowY: "auto",
                    }}
                >
                    {each.child?.map((item, idx) => (
                        <div
                            key={idx}
                            style={{
                                display: "flex",
                                alignItems: "stretch",
                                height: ROW_H,
                                minHeight: ROW_H,
                                borderBottom: `1px solid ${CELL_LINE}`,
                            }}
                        >
                            <span
                                style={{
                                    flexShrink: 0,
                                    width: 28,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: 10,
                                    fontWeight: 700,
                                    color: "#cbd5e1",
                                    background: "#fafbfc",
                                    borderRight: `1px solid ${CELL_LINE}`,
                                }}
                            >
                                {idx + 1}
                            </span>
                            <span style={{...cellLabelStyle, width: 64}}>점검항목</span>
                            <div style={{...valueCellStyle, flex: "1.1 1 0"}}>
                                {status !== "VIEW" ? (
                                    <SimmsInput
                                        onChange={(v) => handleChild(index, "name", v, idx)}
                                        data={item.name}
                                        placeHolder="항목명"
                                        style={inputStyle}
                                    />
                                ) : (
                                    <ReadOnlyInputBasic target="name" value={item.name} />
                                )}
                            </div>
                            <span style={{...cellLabelStyle, width: 64}}>점검내용</span>
                            <div style={{...valueCellStyle, flex: "1.3 1 0"}}>
                                {status !== "VIEW" ? (
                                    <SimmsInput
                                        onChange={(v) => handleChild(index, "etc", v, idx)}
                                        data={item.etc}
                                        placeHolder="점검 내용"
                                        style={inputStyle}
                                    />
                                ) : (
                                    <ReadOnlyInputBasic target="etc" value={item.etc} />
                                )}
                            </div>
                            <span style={{...cellLabelStyle, width: 44}}>타입</span>
                            <div
                                style={{
                                    ...valueCellStyle,
                                    flex: "0 0 120px",
                                    minWidth: 120,
                                    alignItems: "center",
                                    padding: "0 4px",
                                    borderRight: status !== "VIEW" ? `1px solid ${CELL_LINE}` : "none",
                                }}
                            >
                                {status !== "VIEW" ? (
                                    <SimmsSelect
                                        onChange={(v) => handleChild(index, "type", v, idx)}
                                        options={inputType}
                                        data={item.type}
                                        style={selectStyle}
                                    />
                                ) : (
                                    <ReadOnlyInputBasic target="type" value={inputType[item.type].name} />
                                )}
                            </div>
                            {status !== "VIEW" && (
                                <button
                                    type="button"
                                    aria-label="항목 삭제"
                                    style={removeBtnStyle}
                                    onClick={() => removeChild(index, idx)}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.color = "#e42939";
                                        e.currentTarget.style.background = "#fff0f0";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.color = "#b0b8c1";
                                        e.currentTarget.style.background = "#fff";
                                    }}
                                >
                                    ×
                                </button>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    return (
        <>
            {children && children.length > 0 && children.map((each, index) => (
                <Section
                    key={`${each.groupName}-${index}`}
                    title={each.groupName}
                    addElement={
                        status !== "VIEW" && (
                            <button
                                type="button"
                                onClick={() => removeGroup(index)}
                                className="text-[#bd1111] text-xs border border-[#bd1111] px-2 py-[2px] hover:bg-[#bd1111] hover:text-white transition-colors"
                            >
                                삭제
                            </button>
                        )
                    }
                >
                    <table className="w-full create-table">
                        <tbody>
                            {each.child && each.child.map((item, idx) => (
                                <tr key={idx}>
                                    <Th_title title="점검항목" colspan={1}>
                                        {status !== "VIEW" ? (
                                            <SimmsInput
                                                onChange={(v) => handleChild(index, "name", v, idx)}
                                                data={item.name}
                                                style={{width: "96%", marginRight: "5px"}}
                                            />
                                        ) : (
                                            <ReadOnlyInputBasic target="name" value={item.name} />
                                        )}
                                    </Th_title>
                                    <Th_title title="점검내용" colspan={1}>
                                        {status !== "VIEW" ? (
                                            <SimmsInput
                                                onChange={(v) => handleChild(index, "etc", v, idx)}
                                                data={item.etc}
                                                style={{width: "96%", marginRight: "5px"}}
                                            />
                                        ) : (
                                            <ReadOnlyInputBasic target="etc" value={item.etc} />
                                        )}
                                    </Th_title>
                                    <Th_title title="타입" colspan={1} className="pl-1.5">
                                        {status !== "VIEW" ? (
                                            <SimmsSelect
                                                onChange={(v) => handleChild(index, "type", v, idx)}
                                                options={inputType}
                                                data={item.type}
                                                style={{width: "100%"}}
                                            />
                                        ) : (
                                            <ReadOnlyInputBasic target="type" value={inputType[item.type].name} />
                                        )}
                                    </Th_title>
                                    {status !== "VIEW" && (
                                        <Th_title title="관리" colspan={1} className="min-w-[70px]">
                                            <Button
                                                type="button"
                                                variant="outline"
                                                onClick={() => removeChild(index, idx)}
                                                className="h-[32px] ml-1 w-[90%] flex items-center justify-center"
                                            >
                                                삭제
                                            </Button>
                                        </Th_title>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {status !== "VIEW" && (
                        <div className="flex justify-center gap-2 mt-2">
                            <div
                                type="button"
                                onClick={() => addChild(index)}
                                className="w-[30px] h-[30px] rounded-full border flex items-center justify-center text-[20px] cursor-pointer"
                            >
                                +
                            </div>
                        </div>
                    )}
                </Section>
            ))}
        </>
    );
}

export {InspectionReportCodeChildren};
